import { IAssemblyPresidentDTO } from 'DTOModels/assemblyPresidentDTO';

export enum ModalMode {
    Edit = 'Edit',
    Create = 'Create',
}

export interface IEditCurrentAssemblyPresidentModalProps {
    modalVisibility: boolean;
    close: () => void;
    mode?: ModalMode;
    item?: IAssemblyPresidentDTO;
    updateList: () => void;
}

export interface IEditCurrentAssemblyPresidentForm {
    name?: string;
    mandateStartDate: moment.Moment | null;
    photo?: any;
    description?: string;
}
